<template>
  <div class="backdrop">
    <transition name="fade-scale" appear>
      <div v-if="show" class="region-popup">
        <!-- <span class="closebtn pointer" @click="regionSelect"></span> -->
        <div class="region-popup--inner">
          <h2 class="text-blue-p text-center pb-2xl">Welcome to MIS Implants</h2>
          <h4 class="text-center font-rg pb-xl">Please choose your language/region:</h4>          
          <!--
          <div class="region-links text-center px-xl">
            <abtn
              v-for="region in mainRegions"
              color = "transparent"
              :id = "'reg_' + region.ln + '_' + region.cc"
              :key="region.ln+region.cc"
              :icon="region.name === 'Global' ? 'fal fa-globe' : 'slot'"
              :class="['m-xs', region.name === 'Global' ? '' : 'with-img']"
              @click.native="regionSelect(region.ln, region.cc)"
            >
              <img v-if="region.name !== 'Global'" slot="icon" :src="`/img/flags/${region.cc}.svg`"/>
              <span v-text="region.name"></span>
            </abtn>
          </div>-->

          <div class="region-links text-center px-xl">
            <abtn
              v-for="region in restOfRegions"
              color = "transparent"
              :id = "'reg_' + region.ln + '_' + region.cc"
              v-bind:href = "getRegionLink(region.ln)"
              v-bind:target = "getTarget(region.ln)"
              :key="region.cc"
              :icon="region.name === 'Global' ? 'fal fa-globe' : 'slot'"
              :class="['m-xs', region.name === 'Global' ? '' : 'with-img']"
              @click.native="regionSelect(region.ln, region.cc)"
            >
              <img v-if="region.name !== 'Global'" slot="icon" :src="`/img/flags/${region.cc}.svg`"/>
              <span v-text="region.name"></span>
            </abtn>
          </div>
          <div class="block pt-3xl text-center">
            <!-- <logo /> -->
            <img class="dsLogo" :src="'/img/mis-ds-logo-gray.png'" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { storage } from "@/utils";
import { subdomain } from "@/utils";

export default {
  data() {
    return {
      show: false,
      regions: [] //taken from PUBLIC/CLIENT.CONFIG.JS
    };
  },

  methods: {
    ...mapActions(["setLocale"]),
    getTarget(region_ln)
    {
        //v-bind:target = "region.ln == 'br' ? '_blank' : '_self'"
      if (region_ln == 'br' || region_ln == 'cn' ){
        return "_blank";
      }else{
        return '_self';
      }

    },
    getRegionLink(region_ln)
    {
      //v-bind:href = "region.ln == 'br' ? 'https://misimplantes.com.br/' : ''"
      if (region_ln == 'br' ){
        return "https://misimplantes.com.br";
      }
      else if (region_ln == 'cn' ){
        return "https://www.mis-implants.cn";
      }
      else if(region_ln == 'kr')
      {
        return "https://www.mis-implants-korea.com/";      
      }else{
        return '';
      }


    },
    regionSelect(ln, cc) {
      if(ln!='br' && ln!='cn')
      {
        console.log("LN > ", ln, " :: ", cc);
        let locale = ln && cc ? `${ln}-${cc}` : "en";
        this.setLocale(locale);
        storage.set(`MIS-locale`, locale, localStorage);
        this.$emit("local-selected", locale);
      }
    }
  },
  created()
  {
    this.regions = APP_CONFIG.APP_REGIONS;
  },
  mounted() {
    setTimeout(
      function() {
        this.show = true;
      }.bind(this),
      200
    );
  },
  computed: {
    mainRegions() {
      // FIRST TWO REGIONS (USA, GLOBAL)
      if(subdomain()=='patient' || subdomain()=='lab'){
        return _.filter(this.regions, { 'cc': '' });
      }else{
        return _.take(this.regions,2);
      }
    },
    restOfRegions() {
      //if(subdomain()=='patient')// || subdomain()=='lab'){
        //{
        //return _.filter(this.regions, { 'cc': 'es' });
      //}else{
        return this.regions;//_.takeRight(this.regions, this.regions.length - 2);
      //}

    }
  }
};
</script>

<style scoped>
.btn {
    min-width: 135px !important;
    padding-left: 20px !important;

}

</style>
<style lang="stylus" scoped>
.dsLogo
  width 180px
  height auto
.backdrop
  position fixed 0 0 0 0
  background rgba(#fff, 0.92)
  z-index 99999999
.closebtn
  position absolute
  top 10px
  right 10px
  &:before
  &:after
    background blue_4
.region-popup
  center()
  z-index 11
  width 95vw
  min-height 40vh
  max-width 900px
  padding 15vh 0 10vh
  background gray_0 url('/img/region-popup-bg.png') no-repeat 0 0 / cover
  box-shadow 0 0 8px rgba(gray_5,0.2)
  _flex(column, nowrap, center, center)
  +below(600px)
    min-height 80vh
  .btn    
    +below(600px)
      _flex(row, nowrap, center, stretch)
      // width 50%
      min-width 162px !important
      height 40px
      padding 0 30px
      border-radius 20px
      & >>>
        img
        i
          max-height 45%
          margin-right 10px
  .mis-logo
    max-height 50px

.region-links  
  _flex(row, wrap, center, center)  
  grid-template-columns repeat(3, 1fr);
  display grid
  +below(800px)
    display grid
    grid-template-columns repeat(2, 1fr)
    justify-content left
  margin 0 auto
  // .btn.with-img
  //   _flex(row, wrap, center, center)
  h2
    font-size responsive 32px 46px
    text-transform uppercase
  h4
    font-size 24px
  // & > a
  //   &:nth-child(1)
  //     margin-left 120px
  //     margin-bottom 30px
  //   &:nth-child(2)
  //     margin-right 120px
  //     margin-bottom 30px
  .btn
    border 0px
</style>
